// Mock data for LabradorLOF.com

export const dogInfo = {
  name: "TARZAN",
  age: 3,
  weight: 35,
  heightBack: 62,
  heightShoulder: "Plus de 62 cm",
  length: 139,
  description: "Musclé et affuté",
  color: "Chocolat",
  breed: "Labrador LOF",
  character: "Doux, obéissant, joueur et très sociable. Excellente santé et tempérament équilibré.",
  health: {
    dysplasia: "OK",
    dna: "OK",
    eyes: "Testé",
    vaccinations: "À jour"
  },
  pedigree: {
    father: "Nayko des jardins d'Eywa LOF",
    mother: "Maloula des lumieres de Sirius LOF",
    grandfather_p: "Gary des cerisiers du Beart LOF",
    grandmother_p: "Lilo des jardins d'Eywa LOF",
    grandfather_m: "Ferrero des forets ephemeres LOF",
    grandmother_m: "Indra de l'ange Quentin"
  }
};

export const pricing = {
  studFee: 390,
  included: [
    "2 saillies (à 48h d'intervalle)",
    "Certificat de saillie signé",
    "Garantie de re-saillie si nécessaire",
    "Accueil et présence du propriétaire"
  ],
  payment: [
    "Paiement à la saillie",
    "Espèces ou virement bancaire",
    "Acompte de 100€ à la réservation"
  ]
};

export const breedingConditions = [
  {
    title: "Documents requis",
    items: [
      "Certificat LOF de la femelle (si disponible)",
      "Carnet de vaccination à jour (obligatoire)",
      "Test de dépistage de la brucellose (moins de 2 mois recommandé)",
      "Tests de dysplasie (fortement recommandé)",
      "Les saillies sont également possibles avec des femelles non LOF",
      "Chaque demande est étudiée au cas par cas afin de garantir la qualité et la santé des futurs chiots"
    ]
  },
  {
    title: "Conditions sanitaires",
    items: [
      "Femelle en bonne santé",
      "Vaccins à jour (CHLRP + rage)",
      "Traitement antiparasitaire récent",
      "Femelle âgée de 2 à 7 ans"
    ]
  },
  {
    title: "Modalités de saillie",
    items: [
      "Saillie au domicile du propriétaire",
      "2 saillies à 48h d'intervalle",
      "Présence obligatoire du propriétaire",
      "Durée : environ 30-45 minutes par saillie"
    ]
  },
  {
    title: "Garanties",
    items: [
      "Re-saillie gratuite en cas d'échec",
      "Certificat de saillie fourni",
      "Conseils et suivi personnalisé",
      "Disponibilité pour répondre aux questions"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie Claude Martinez",
    location: "Bourg en Bresse",
    date: " Janvier 2025",
    text: "Tarzan est un magnifique mâle ! Saillie réussie du premier coup. Le propriétaire est très professionnel et accueillant. Je recommande vivement !",
    rating: 5
  },
  {
    id: 2,
    name: "Sylvain Luc",
    location: "Lyon",
    date: "Aout 2025",
    text: "Excellente expérience ! Tarzan a un tempérament parfait et les chiots sont magnifiques. Merci pour votre sérieux et votre disponibilité.",
    rating: 5
  },
  {
    id: 3,
    name: "Fanny Gerbod",
    location: "Miribel",
    date: "Fevrier 2026",
    text: "Très satisfaite de cette saillie. Le cadre est agréable, le chien est superbe et en excellente santé. Communication parfaite tout au long du processus.",
    rating: 5
  }
];

export const availability = [
  {
    id: 1,
    month: "Mars 2026",
    dates: ["7-8 Mars", "14-15 Mars"],
    status: "available"
  },
  {
    id: 2,
    month: "Avril 2026",
    dates: ["4-5 Avril", "11-12 Avril", "18-19 Avril"],
    status: "available"
  },
  {
    id: 3,
    month: "Mai 2026",
    dates: ["2-3 Mai ", "9-10 Mai", "16-17 Mai"],
    status: "available"
  }
];

export const faqData = [
  {
    question: "Quels documents dois-je fournir pour la saillie ?",
    answer: "Vous devez fournir le certificat LOF de votre femelle, son carnet de vaccination à jour, et un test de brucellose datant de moins de 2 mois. Les résultats des tests de dysplasie sont fortement recommandés."
  },
  {
    question: "Combien de temps dure une saillie ?",
    answer: "Une saillie dure généralement entre 30 et 45 minutes. Nous effectuons 2 saillies à 48h d'intervalle pour maximiser les chances de réussite."
  },
  {
    question: "Que se passe-t-il si la saillie échoue ?",
    answer: "En cas d'échec (pas de gestation confirmée), nous offrons une re-saillie gratuite lors des prochaines chaleurs de votre femelle."
  },
  {
    question: "À quel âge ma femelle peut-elle être saillie ?",
    answer: "Nous acceptons les femelles âgées de 2 à 7 ans, en bonne santé et avec tous les vaccins à jour."
  },
  {
    question: "Comment réserver une date ?",
    answer: "Vous pouvez nous contacter par téléphone (0695134999), WhatsApp ou via le formulaire de contact. Un acompte de 100€ est demandé pour confirmer la réservation."
  },
  {
    question: "Quel est le mode de paiement accepté ?",
    answer: "Nous acceptons les paiements en espèces ou par virement bancaire. Le paiement se fait le jour de la première saillie."
  }
];

export const articles = [
  {
    id: 1,
    title: "Les soins du Labrador",
    excerpt: "Une alimentation équilibrée est essentielle pour la santé de votre Labrador. Découvrez nos conseils nutritionnels.",
    content: "Le Labrador a besoin d'une alimentation riche et équilibrée adaptée à son âge, son poids et son niveau d'activité..."
  },
  {
    id: 2,
    title: "La reproduction responsable",
    excerpt: "Tout ce que vous devez savoir avant de faire reproduire votre femelle Labrador.",
    content: "La reproduction d'un Labrador nécessite une préparation minutieuse et le respect de certaines conditions..."
  },
  {
    id: 3,
    title: "Comprendre le LOF",
    excerpt: "Le Livre des Origines Français (LOF) garantit la pureté de la race. Explications détaillées.",
    content: "Le LOF est le registre officiel des chiens de race en France. Un chien inscrit au LOF bénéficie d'une traçabilité complète..."
  }
];

export const images = {
  hero: "images/izaak3.jpg",
  gallery: [
    "/images/20250621_164805.jpg",
    "/images/izaak.jpg",
    "/images/izaak6.jpg",
    "https://images.unsplash.com/photo-1570670597227-6b01d32f37e8",
    "/images/izaak5.jpg",
    "/images/izaak2.jpg"
  ]
};

export const contactInfo = {
  phone: "0756963191",
  whatsapp: "0756963191",
  email: "contact@labradordesdombes.com",
  address: "Sainte-Olive 01330"
};
